var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fccece"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fba5c2"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.419,
    x2: 263.419,
    xlinkHref: "#lg1",
    y1: 233.003,
    y2: 649.921
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fccece",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bb4966"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.803,
    x2: 502.94,
    xlinkHref: "#lg2",
    y1: 208.263,
    y2: 401.872
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 303.439,
    x2: 26.732,
    xlinkHref: "#lg2",
    y1: 391.707,
    y2: 345.446
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.061,
    x2: 391.061,
    xlinkHref: "#lg1",
    y1: 219.482,
    y2: 308.45
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.327,
    x2: 393.643,
    xlinkHref: "#lg1",
    y1: 443.296,
    y2: 511.841
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.51,
    x2: 394.918,
    xlinkHref: "#lg1",
    y1: 377.75,
    y2: 444.972
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.888,
    x2: 395.478,
    xlinkHref: "#lg1",
    y1: 283.46,
    y2: 390.006
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.253,
    x2: 151.246,
    y1: 245.344,
    y2: 482.332
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#ffde50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#ffca65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#ffaa87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m310.889 210.432 8.126-38.64c9.38-44.605 10.902-90.505 4.498-135.633-2.666-18.784-18.747-32.745-37.72-32.745-22.234 0-39.744 18.961-37.977 41.126l1.069 13.413c2.182 27.369-1.232 54.896-10.033 80.903l-5.848 17.278c-.423 1.251-.862 2.496-1.317 3.733-17.73 48.288-64.447 79.807-115.887 79.807h-32.504v250.726c14.279 0 28.456-2.409 41.933-7.125 25.404-8.889 52.998-9.55 78.733-1.669 62.292 19.076 127.141 33.366 189.819 19.345l49.76-11.132v-279.387z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m185.313 385.491c103.525 0 189.319-75.883 204.814-175.059h-79.237l8.126-38.64c9.38-44.605 10.902-90.505 4.498-135.633-1.185-8.353-5.033-15.741-10.598-21.382-3.129-2.447-6.336-4.798-9.605-7.066-5.271-2.736-11.226-4.297-17.516-4.297-22.235 0-39.744 18.962-37.977 41.126l1.069 13.413c2.182 27.369-1.232 54.896-10.033 80.903l-5.848 17.278c-.424 1.251-.863 2.496-1.317 3.733-17.73 48.288-64.447 79.807-115.887 79.807h-32.506v119.008c30.121 17.06 64.928 26.809 102.017 26.809z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m393.781 500.951 27.758-6.21-262.694-262.694-.001-.012c-13.554 4.961-28.095 7.639-43.042 7.639h-32.506v250.726c14.279 0 28.456-2.409 41.933-7.124 25.404-8.889 52.998-9.55 78.733-1.669 62.292 19.075 127.141 33.365 189.819 19.344z",
    fill: "url(#SVGID_3_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m318.559 203.484-2.315.519c-38.745 8.679-38.745 77.324 0 86.003l2.315.519c48.593 10.885 98.375 10.885 146.968 0 39.212-8.783 39.212-78.256 0-87.04-48.593-10.885-98.374-10.885-146.968-.001z",
    fill: "url(#SVGID_4_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m332.108 423.102-1.882.422c-31.504 7.057-31.504 62.874 0 69.931l1.882.422c39.512 8.851 79.991 8.851 119.503 0 31.884-7.142 31.884-63.632 0-70.774-39.512-8.852-79.99-8.852-119.503-.001z",
    fill: "url(#SVGID_5_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m318.559 342.644-2.315.519c-38.745 8.679-38.745 77.324 0 86.003l2.315.519c48.593 10.885 98.375 10.885 146.968 0 39.212-8.783 39.212-78.256 0-87.04-48.593-10.886-98.374-10.886-146.968-.001z",
    fill: "url(#SVGID_6_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m308.046 279.817-2.651.462c-44.363 7.736-44.363 68.923 0 76.659l2.651.462c55.64 9.702 112.64 9.702 168.28 0h.001c44.898-7.829 44.898-69.754 0-77.583-55.641-9.703-112.641-9.703-168.281 0z",
    fill: "url(#SVGID_7_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m136.895 498.31h-107.197c-16.402 0-29.698-13.296-29.698-29.698v-216.563c0-16.402 13.296-29.698 29.698-29.698h107.197c16.402 0 29.698 13.296 29.698 29.698v216.563c0 16.402-13.296 29.698-29.698 29.698z",
    fill: "url(#SVGID_8_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLike);
export default __webpack_public_path__ + "static/media/icon-like.26c87516aa02e870a6181fa9b7596b16.svg";
export { ForwardRef as ReactComponent };